<template>
  <a-card :loading="loading.page" class="manifestMCMAP">
    <div slot="title" class="m-display-flex space-between custom">
      <span class="cmain-title"><a-icon type="project" />&nbsp;Manifest Cash Management - {{ titles }}</span>
    </div>
    <a-row :gutter="8" :class="getScreen ? 'h_MCMAP-h_col' : 'h_MCMAP'">
      <a-col :xs="{ span: 24 }" :lg="{ span: 14 }">
        <a-collapse v-model="activeKey.header" :activeKey="activeKey.header">
          <a-collapse-panel key="1">
            <span slot="header">
              <div v-if="titles=='Annual Plafon'" class="m-display-flex space-between align-middle m-width-full">
                <div>
                  Type : {{ manifest.header[0] ? manifest.header[0].type_label : "-" }}
                  Year : {{ selected.year ? selected.year : "-" }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  Version : {{ selected.version ? selected.version : "-" }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </div>
                <div>
                </div>
              </div>
              <div v-if="titles=='Monthly Plafon'" class="m-display-flex space-between align-middle m-width-full">
                <div>
                  Type : {{manifest.header[0].type_label }}
                  &nbsp;&nbsp;&nbsp;Period : {{ moment(manifest.header[0].month_start).format('MM-YYYY') }}
                   to 
                  {{ moment(manifest.header[0].month_end).format('MM-YYYY') }}
                   &nbsp;&nbsp;&nbsp;Version : {{ manifest.header[0].version }}
                </div>
                <div>
                </div>
              </div>
            </span>
            <a-card class="headers">
              <!-- <div v-if="titles=='Monthly Plafon'">
                <div><b>Period :</b></div>
                <div>{{ moment(manifest.header[0].month_start).format('MM-YYYY') }} to {{ moment(manifest.header[0].month_end).format('MM-YYYY') }}</div>
              </div> -->
              <a-row :gutter="8">
                <!-- <a-col :xs="{ span: 24 }" :lg="{ span: 12 }" v-if="titles=='Annual Plafon'">
                  <div><b>Total Est. Contract Value :</b></div>
                  <div>{{ formatCurrency('IDR',manifest.header[0].est_contract_value ? manifest.header[0].est_contract_value : 0) }}</div>
                </a-col> -->
                <!-- <a-col :xs="{ span: 24 }" :lg="{ span: 6 }">
                  <div><b>Est. CashFlow Value :</b></div>
                  <div>{{ formatCurrency('IDR',manifest.header[0].cashflow_value ? manifest.header[0].cashflow_value : 
                    (manifest.header[0].est_cashflow_value ? manifest.header[0].est_cashflow_value : 0)
                    ) }}
                  </div>
                </a-col> -->
                <!-- <a-col :xs="{ span: 24 }" :lg="{ span: 24 }" v-if="manifest.header[0].type=='X_ABAIKAN_X'">
                  <div><b>Est. Pipeline Value :</b></div>
                  <div>{{ formatCurrency('IDR',manifest.header[0].estimatepipelineplafon ? manifest.header[0].estimatepipelineplafon : 0) }}
                  </div>
                </a-col>
                <a-col :xs="{ span: 24 }" :lg="{ span: 24 }" v-if="manifest.header[0].type=='X_ABAIKAN_X'">
                  <div><b>Est. Directorate Cost :</b></div>
                  <div>{{ formatCurrency('IDR',manifest.header[0].estimatedirectoratecost ? manifest.header[0].estimatedirectoratecost : 0) }}
                  </div>
                </a-col> -->
                <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
                  <div><b>Total Plafon :</b></div>
                  <div>{{ formatCurrency('IDR',manifest.header[0].total_plafon ? manifest.header[0].total_plafon : 0) }}</div>
                </a-col>
              </a-row>
              <!-- <a-row :gutter="8">
                <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
                  <div><b>Total Plafon :</b></div>
                  <div>{{ formatCurrency('IDR',manifest.header[0].total_plafon ? manifest.header[0].total_plafon : 0) }}</div>
                </a-col>
                <a-col :xs="{ span: 24 }" :lg="{ span: 8 }" v-if="manifest.header[0] && manifest.header[0].type=='X_ABAIKAN_X'">
                  <div><b>Total Pipeline :</b></div>
                  <div>{{ formatCurrency('IDR',manifest.header[0].totalpipelineplafon ? manifest.header[0].totalpipelineplafon : 0) }}</div>
                </a-col>
                <a-col :xs="{ span: 24 }" :lg="{ span: 8 }" v-if="manifest.header[0] && manifest.header[0].type=='X_ABAIKAN_X'">
                  <div><b>Total Directorate Cost :</b></div>
                  <div>{{ formatCurrency('IDR',manifest.header[0].totaldirectoratecost ? manifest.header[0].totaldirectoratecost : 0) }}</div>
                </a-col>
              </a-row> -->
              <div class="margin-top"><b>Plafon Value Directorate :</b></div>
              <a-card :bordered="false" >
                <a-row type="flex">
                  <div v-for="item in manifest.dtl" :key="item.id_dtl" :style="getScreen ? 'width:100%' : 'width:50%'">
                    <div class="margin-top"><u><b>{{ item.directorat }}</b></u></div>
                    <div style="margin-right:25px">
                      <div class="m-display-flex space-between">
                        <span>Plafon : </span> <span>{{ formatCurrency('IDR', item.plafon_value) }}</span>
                      </div>
                      <div class="m-display-flex space-between" v-if="manifest.header[0] && manifest.header[0].type=='X_ABAIKAN_X'">
                        <span>Pipeline : </span> <span>{{ formatCurrency('IDR', item.pipeline_plafon) }}</span>
                      </div>
                      <div class="m-display-flex space-between" v-if="manifest.header[0] && manifest.header[0].type=='X_ABAIKAN_X'">
                        <span>Directorate : </span> <span>{{ formatCurrency('IDR', item.biaya_direktorat_plafon) }}</span>
                      </div>
                    </div>
                  </div>
                </a-row>
                <!-- <div v-for="item in manifest.dtl" :key="item.id_dtl" class="boxsa">
                  <div><b>{{ item.directorat }}</b></div>
                  <div>{{ formatCurrency('IDR', item.plafon_value) }}</div>
                </div> -->
              </a-card>
            </a-card>
          </a-collapse-panel>
        </a-collapse>
        <a-collapse activeKey="1" class="margin-top">
          <a-collapse-panel key="1">
            <span slot="header" class="m-display-flex space-between">
              <div>Upload Attachment</div>
              <div>
                <a-button size="small" class="margin-right" @click="showUploadDialog"> <a-icon type="upload" />Upload</a-button>
              </div>
            </span>
            <a-list
                bordered
                :dataSource="modalUpload.list"
                class="doc-viewer edit margin-top"
                size="small"
              >
                <a-list-item slot="renderItem" slot-scope="item, index">
                  <a-list-item-meta>
                    <div slot="description">
                      <div class="m-display-flex space-between align-middle">
                        <div><a @click="showFiles(item.path_file)">{{index+1}}. {{item.deskripsi}}</a></div>
                        <!-- <a-button icon="delete" type="danger" @click="handleRemove(item.deskripsi)"></a-button> -->
                      </div>
                    </div>
                  </a-list-item-meta>
                </a-list-item>
              </a-list>
          </a-collapse-panel>
        </a-collapse>
      </a-col>
      <a-col :xs="{ span: 24 }" :lg="{ span: 10 }">
        <a-collapse class="" activeKey="1">
          <a-collapse-panel key="1">
            <div
              class="m-display-flex space-between align-middle m-width-full"
              slot="header"
            >
              <h4 class="margin-remove">Status</h4>
              <div>
                <Status :status="manifest.header[0].status.toUpperCase()==='ACTIVE' ? 'Active' : manifest.header[0].status" />
              </div>
            </div>
            <a-timeline class="m-timeline">
              <a-timeline-item color="green">
                <div class="m-timeline-title">
                  Pembuat - {{ manifest.header[0].tlc_create }}
                </div>
                <div class="m-timeline-body">
                  <h4 class="margin-remove">{{ manifest.header[0].create_dt }}</h4>
                </div>
                <div class="m-timeline-footer">
                  <Status :status="'Created'"/>
                </div>
              </a-timeline-item>
              <a-timeline-item
                v-for="workflow in manifest.workflow"
                :key="workflow.step_no"
                :color="
                  workflow.status === 'On Process' ||
                  workflow.status === 'Delivered'
                    ? 'red'
                    : workflow.status === 'Waiting'
                    ? 'grey'
                    : 'green'
                "
              >
                <div class="m-timeline-title">
                  {{
                    workflow.actor === null ? workflow.jenis : workflow.actor
                  }}
                  {{ workflow.tlc ? " - " + workflow.tlc : "" }}
                </div>
                <div class="m-timeline-body">
                  <h4
                    class="margin-remove"
                    v-if="workflow.tanggal_aksi !== null"
                  >
                    {{ workflow.tanggal_aksi }}
                  </h4>
                  <span
                    class="m-text-small"
                    v-if="workflow.remark == null || workflow.remark == ''"
                    >Tidak Ada Catatan</span
                  >
                  <span class="m-text-small" v-else>{{ workflow.remark }}</span>
                </div>
                <div class="m-timeline-footer">
                  <Status :status="workflow.status" />
                </div>
              </a-timeline-item>
            </a-timeline>
          </a-collapse-panel>
        </a-collapse>
      </a-col>
    </a-row>
    <a-row :gutter="8">
      <a-col :xs="{ span: 24 }" :lg="{ span: 14 }">
        <a-card class="margin-top" v-if="manifest.aksi.length>0">
          <div slot="title">Manifest Actions</div>
          <a-form :form="form">
            <a-form-item label="Note">
              <a-textarea
                placeholder="Write the note here ... "
                :rows="2"
                v-decorator="['catatan']"
              />
            </a-form-item>
            <a-form-item label="Actions">
              <a-select
                showSearch
                v-decorator="['aksi', { rules: [{ required: true }] }]"
              >
                <a-select-option v-for="item in manifest.aksi" :key="item.aksi">{{
                  item.aksi
                }}</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item :wrapper-col="{ span: 24 }">
              <a-button
                @click="handleSubmit"
                :loading="loading.save"
                block
                type="primary"
                html-type="submit"
                >Save</a-button
              >
            </a-form-item>
          </a-form>
        </a-card>
      </a-col>
      <a-col :xs="{ span: 24 }" :lg="{ span: 10 }">

      </a-col>
    </a-row>

    <a-modal v-model="modalUpload.visible" v-if="modalUpload.visible" @ok="handleUpload" @cancel="handleUploadClose"
      :maskClosable="false">
      <span slot="title"> <a-icon type="upload" />&nbsp;Upload Attachment </span>
        <a-form-item label="Upload Document File" required>
          <a-upload
            :showUploadList="true"
            :fileList="modalUpload.push"
            :beforeUpload="beforeUpload"
            :remove="handleRemoveUpload"
            v-decorator="['upload_file_support', { rules: [{ required: true, validator: validateUpoadFile }], 
            valuePropName: 'push' }]"
          >
            <a-button size="small" class="margin-right"> <a-icon type="upload" />Upload</a-button>
          </a-upload>
        </a-form-item>
        <template slot="footer">
          <a-button key="submit" type="primary" class="m-width-full" 
            :disabled="modalUpload.push.length==0"
            @click="handleUpload" :loading="loading.saveModalUpload">
            Submit
          </a-button>
        </template>
    </a-modal>
  </a-card>
</template>
<script>
import { mapGetters, mapActions } from "vuex"
import GlobalMethod from "@/mixins/GlobalMethod.js"
import CurrencyFormat from "@/mixins/CurrencyFormat"
import moment from "moment";

export default {
  name: "ManifestMonthlyAnnual",
  props:["id"],
  mixins: [GlobalMethod, CurrencyFormat],
  data(){
    return {
      loading:{
        page: false,
        save: false,
        saveModalUpload: false,
      },
      selected:{
        year: "",
        version: ""
      },
      activeKey:{
        header: "1",
      },
      manifest: {
        header: [{
          year: "",
          version: "",
          status: "",
          create_dt: "",
          tlc_create: ""
        }],
        workflow: [],
        dtl: [],
        aksi: []
      },
      modalUpload:{
        push: [],
        list: [],
        visible: false
      }
    }
  },
  created(){
    this.form = this.$form.createForm(this);
    this.fetch()
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getDefaultDateFormat",
      "getAuth",
      "getDateTimeFormat",
    ]),
    isVPF(){
      return this.$route.path.includes('/vpf') ? true :false
    },
    titles(){
      return this.$route.path.includes("MonthlyAnnualManifest/1/") ? "Annual Plafon" : "Monthly Plafon"
    }
  },
  methods:{
    moment,
    async fetch(){
      this.loading.page = true
      await this.asyncAxiosGet("plafon/"+(this.titles=="Annual Plafon" ? "annual" : "monthly"),
        this.getAuth, { id: this.id }
      )
      .then((res) => {
        this.selected.year = res.header[0].year
        this.selected.version = res.header[0].version
        this.manifest = res
        this.modalUpload.list = this.manifest.doc
        // this.year = res.filter_year
        // this.versionOri = res.filter_version
        // this.version = this.versionOri.filter((item) => item.year==res.header[0].year)
        // this.manifest.header[0] = res.header[0]
        // this.dtl = res.dtl
        // this.selected.year = res.header[0].year
        // this.selected.version = res.header[0].version

        this.loading.page = false
      })
    },
    handleSubmit() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.loading.save = false;
          this.displayMessage("choose-action");
          return;
        }

        let postData = new FormData();

        postData.append("id", this.id);
        postData.append("status", values.aksi);
        postData.append(
          "remark",
          values.catatan !== undefined ? values.catatan : ""
        );

        this.loading.save = true;
        this.asyncAxiosPost("plafon/"+(this.titles=="Annual Plafon" ? "approval" : "approval_monthly"), "formdata", this.getAuth, postData)
          .then(() => {
            this.loading.save = false;
            this.displayMessage("success");
            this.$router.go();
          })
          .catch((err) => {
            // console.log("error : " + err);
            if (err.response.data.status === false) {
              this.displayMessage("wrong-password");
            }
            this.loading.save = false;
          });
      });
    },
    validateUpoadFile(rule, value, callback){
      if (this.modalUpload.push.length > 0) {
        callback();
        return;
      }
      // uncomment untuk return false muncul
      // callback("Upload File Support is required!");
    },
    beforeUpload(file){
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 5) {
        this.displayMessage("large-file-5mb");
      } else {
        this.modalUpload.push = []
        this.modalUpload.push.push(file)
        return false;
      }
    },
    showUploadDialog(e){
      e.stopPropagation();
      this.modalUpload.visible = true;
    },
    handleUpload(){
      let formData = new FormData();
      formData.append("id", this.id);
      formData.append(`document_support`, this.modalUpload.push[0]);

      this.loading.saveModalUpload = true
      this.asyncAxiosPost(this.titles=='Monthly Plafon' ? "plafon/monthly_doc" : "plafon/annual_doc",
        "formdata", this.getAuth, formData)
      .then((result) => {
        this.displayMessage("success-save");
        this.loading.saveModalUpload = false
        this.modalUpload.visible = false
        this.modalUpload.list = result.doc
      })
      .catch(() => {
        this.loading.saveModalUpload = false
      });
    },
    handleUploadClose(){
      this.modalUpload.visible = false;
    },
    handleRemoveUpload(e){
      this.modalUpload.push = this.modalUpload.push.filter((file)=> {console.log(file.name,e.name);return file.name!=e.name})
    },
    showFiles(path_file){
      window.open(this.$serviceUrl + path_file, '_blank')
    }
  },
  watch: {
    id() {
      this.fetch()
    }
  }
}
</script>
<style lang="less">
.manifestMCMAP{
  .headers{
    .ant-card-body{
      line-height: 2;
    }
  }
  /*.h_MCMAP{
    &-h_col{
      flex-direction: column;
    }
    display: flex;
    .ant-col{
      display: flex;
      flex-direction: column;
      .ant-collapse{
        display: flex;
        flex-direction: column;
        flex: 1;
        .ant-collapse-item{
          display: flex;
          flex-direction: column;
          flex: 1;
          .ant-collapse-header{
            display: flex;
          }
          .ant-collapse-content{
            display: flex;
            flex-direction: column;
            flex: 1;
            .ant-collapse-content-box{
              flex-grow: 1;
              .ant-card{
                height: 100%;
              }
            }
          }
        }
      }
    }
  }
    */
}
</style>